import { useEffect } from 'react';

import { isScrollIgnored } from '../components/overlay-tooltip/utils/is-scroll-ignored.js';

export const useApplyCallbackOnScroll = (
  disabled: boolean,
  callback: () => void,
): void => {
  useEffect(() => {
    if (disabled) {
      return;
    }

    const handleScroll = (event: Event) => {
      if (isScrollIgnored(event)) {
        return;
      }
      callback();
    };

    document.body.addEventListener('scroll', handleScroll, true);
    return () =>
      document.body.removeEventListener('scroll', handleScroll, true);
  }, [disabled]);
};
